import * as tslib_1 from "tslib";
import { ElementRef, OnDestroy, OnInit } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { AppService } from '@app/Modules/Shared/Services/app.service';
import { HttpService } from '@app/Modules/Shared/Services/http.service';
import { LocationLanguageService } from '@app/Modules/Shared/Services/location-language.service';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { waysToContactDropdown } from "@app/conf/dataConfigurations";
import { GlobalAppService } from '@app/Modules/Shared/Services/global-app.service';
import { LanguageSelectionService } from '@app/Modules/Shared/Services/language-selection.service';
import { MessageService } from 'primeng/api';
import { Router } from '@angular/router';
var SensitiveDataComponent = /** @class */ (function () {
    function SensitiveDataComponent(_appService, httpService, locationLanguageService, fb, activatedRoute, translateService, _globalAppService, languageService, messageService, router) {
        this._appService = _appService;
        this.httpService = httpService;
        this.locationLanguageService = locationLanguageService;
        this.fb = fb;
        this.activatedRoute = activatedRoute;
        this.translateService = translateService;
        this._globalAppService = _globalAppService;
        this.languageService = languageService;
        this.messageService = messageService;
        this.router = router;
        this.isLoggedIn = false;
        this.templateConfig = {
            "region": {
                display: true,
                order: "1"
            },
            "country": {
                display: true,
                order: "2"
            },
            "salesOrg": {
                display: true,
                order: "3"
            },
            "language": {
                display: true,
                order: "4"
            }
        };
        this.isGlobalUser = false;
        this.errorOnCPRA = false;
    }
    Object.defineProperty(SensitiveDataComponent.prototype, "selectedLocationLanguage", {
        get: function () {
            return this._selectedLocationLanguage;
        },
        set: function (value) {
            this._selectedLocationLanguage = value;
            // this.setDefaultLocation();
        },
        enumerable: true,
        configurable: true
    });
    SensitiveDataComponent.prototype.ngOnDestroy = function () {
    };
    SensitiveDataComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.isGlobalUser = this._appService.isGlobalUser;
        this.waysToContactDropdown = waysToContactDropdown;
        this.region = this._globalAppService.getDefaultRegionString();
        if (this.region == "NA") {
            this.regionNA = true;
        }
        else {
            this.regionNA = false;
        }
        this.language = this._globalAppService.getDefaultLanguageString() || 'en-US';
        this._globalAppService.getDefaultRegion().subscribe(function (region) {
            if (region) {
                _this.region = region;
                _this._globalAppService.getDefaultLanguage().subscribe(function (lang) {
                    if (region && lang) {
                        _this.language = lang;
                        _this.translateService.setDefaultLang(_this.region + '/' + _this.languageService.getLanguageCode(_this.region, _this.language).toLowerCase());
                    }
                });
            }
        });
        if (this._appService.AvailableOKtaProfile) {
            this.oktaProfile = this._appService.AvailableOKtaProfile;
            this.isLoggedIn = true;
            if (!this.isLoggedIn) {
                this.loadLocationLanguageData();
            }
            else {
                this.httpService.getUserProfile(this._appService.getuserId(false)).subscribe(function (data) {
                    if ((data && data['defaultCustomerInfo'] && data['defaultCustomerInfo'].length)) {
                        _this.userProfileData = data["defaultCustomerInfo"][0];
                    }
                });
                this.translateService.setDefaultLang(this.region + '/' + this.languageService.getLanguageCode(this.region, this.language).toLowerCase());
            }
        }
        else {
            this.loadLocationLanguageData(false, true);
        }
        this.languageService.getlanguage().subscribe(function (language) {
            _this.getLanguageChange(language);
        });
        var selectedCountryLang = { country: 'US', language: 'en-US', salesOrg: 0 };
        var currentLanguage = this._globalAppService.getDefaultLanguageString() || 'en-US';
        if (selectedCountryLang && selectedCountryLang.language) {
            currentLanguage = selectedCountryLang.language;
        }
        // this.getLanguageChange(currentLanguage);
        this.getLanguageChange(currentLanguage);
        this.populateUserDetails();
        // debugger
    };
    SensitiveDataComponent.prototype.getGlobalUserDetails = function (username) {
        var userId = this._appService.getuserId(true);
        this.globalUserName = username + "( " + userId + " )";
    };
    SensitiveDataComponent.prototype.getLanguageChange = function (language) {
        if (language)
            this.translateService.use(this.region + '/' + this.languageService.getLanguageCode(this.region, language).toLowerCase());
        // this.translateService.get(['dataConfigData.waysToContactDropdown.select']).subscribe(translations =>{
        //   this.selectLabel = translations['dataConfigData.waysToContactDropdown.select'];
        // })
    };
    SensitiveDataComponent.prototype.loadLocationLanguageData = function (isLoadingOnDrownDownChanges, isOnLoad) {
        var _this = this;
        if (isLoadingOnDrownDownChanges === void 0) { isLoadingOnDrownDownChanges = false; }
        if (isOnLoad === void 0) { isOnLoad = false; }
        var languageFromParams = this.activatedRoute.snapshot.queryParamMap.get('language');
        if (languageFromParams && isOnLoad) {
            this.httpService.getLocationsWithDefaultLanguage(languageFromParams).subscribe(function (locations) {
                if (locations && locations.response && locations.response.length) {
                    _this.locationLanguageService.setLocationLanguageData(locations.response);
                    _this.populateLocations(isLoadingOnDrownDownChanges);
                    _this.initPage();
                    _this.loadContactContent(_this.selectedLocationLanguage);
                }
            });
        }
        else {
            this.httpService.getLocations().subscribe(function (locations) {
                if (locations && locations.response && locations.response.length) {
                    _this.locationLanguageService.setLocationLanguageData(locations.response);
                    _this.populateLocations(isLoadingOnDrownDownChanges);
                    _this.initPage();
                    _this.loadContactContent(_this.selectedLocationLanguage);
                }
            });
        }
    };
    SensitiveDataComponent.prototype.populateLocations = function (isLoadingOnDrownDownChanges) {
        var _this = this;
        if (isLoadingOnDrownDownChanges === void 0) { isLoadingOnDrownDownChanges = false; }
        if (!isLoadingOnDrownDownChanges) {
            this.setDefaultLocation();
        }
        this._globalAppService.setDefaultRegion(this.selectedLocationLanguage.region);
        this.regions = this.locationLanguageService.getAllRegions();
        this.regions = this.regions && this.regions.length ? this.regions.sort() : null;
        if (!this.selectedLocationLanguage || !this.selectedLocationLanguage.region) {
            this.selectedLocationLanguage = {
                region: this.regions[0].value
            };
        }
        this.countries = this.locationLanguageService.getCountriesForRegion(this.selectedLocationLanguage.region);
        this.countries = this.countries && this.countries.length ? this.countries.sort() : null;
        if (!this.selectedLocationLanguage || !this.selectedLocationLanguage.country) {
            this.selectedLocationLanguage = {
                region: this.regions[0].value,
                country: this.countries[0].value
            };
            this.selectedCountryLabel = this.countries.find(function (c) {
                return c.value === _this.selectedLocationLanguage.country;
            }).label;
            this.selectedCountryValue = this.countries.find(function (c) {
                return c.value === _this.selectedLocationLanguage.country;
            }).value;
        }
        this.languages = this.locationLanguageService.getLanguagesForCountry(this.selectedLocationLanguage.region, this.selectedLocationLanguage.country);
        this.languages = this.languages && this.languages.length ? this.languages.sort() : null;
        if (!this.selectedLocationLanguage || !this.selectedLocationLanguage.language) {
            this.selectedLocationLanguage = {
                region: this.regions[0].value,
                country: this.countries[0].value,
                language: this.languages[0].value
            };
        }
        this.dataLoaded = true;
    };
    SensitiveDataComponent.prototype.initFormGroup = function () {
        if (this.selectedRegion === 'APAC') {
            this.locationLanguageSelectorForm = this.fb.group({
                region: [''],
                country: [''],
                salesOrg: [''],
                language: ['']
            });
        }
        else {
            this.locationLanguageSelectorForm = this.fb.group({
                region: [''],
                country: [''],
                language: ['']
            });
        }
    };
    SensitiveDataComponent.prototype.loadcomponentConfig = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var locationLanguageSelector;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this._appService.dynamicImport(this.selectedLocationLanguage.region)];
                    case 1:
                        locationLanguageSelector = (_a.sent()).locationLanguageSelector;
                        Object.assign(this.templateConfig, locationLanguageSelector);
                        return [2 /*return*/];
                }
            });
        });
    };
    SensitiveDataComponent.prototype.presetSelectLocationValues = function () {
        var inputParameter = { 'value': this.defaultRegion };
        this.locationLanguageSelectorForm.get('region').setValue(this.defaultRegion);
        // this.onRegionChange(inputParameter)
    };
    // formChangesListener() {
    //   let me = this;
    //   this.locationLanguageSelectorForm.valueChanges.subscribe(changes => {
    //     me.loadContactContent(changes);
    //   })
    // }
    SensitiveDataComponent.prototype.initPage = function () {
        this.loadcomponentConfig();
        this.initFormGroup();
        this.autoSelectLocationValues();
        if (this.defaultRegion) {
            this.presetSelectLocationValues();
        }
    };
    SensitiveDataComponent.prototype.setDefaultLocation = function () {
        // Check for query params storage first ir not available read from browser storage
        if (this.activatedRoute.snapshot.queryParams && Object.keys(this.activatedRoute.snapshot.queryParams).length) {
            this.readQueryParams();
        }
        else if (typeof (Storage) !== 'undefined' && localStorage.getItem("KCC.CP.selectedLocationLanguage") && localStorage.getItem("KCC.CP.selectedLocationLanguage") !== 'undefined') {
            this.readLocationFromLocalStorage();
        }
        else {
            this.selectedLocationLanguage = {
                region: "LAO",
                country: "AR",
                language: 'es-AR'
            };
        }
        this.translateService.setDefaultLang(this.selectedLocationLanguage.region + '/' + this.languageService.getLanguageCode(this.selectedLocationLanguage.region, this.selectedLocationLanguage.language).toLowerCase());
    };
    SensitiveDataComponent.prototype.autoSelectLocationValues = function () {
        this.selectedRegion = this.locationLanguageService.doesRegionExists(this.selectedLocationLanguage.region, this.regions) ? this.selectedLocationLanguage.region : this.regions[0].value;
        this.selectedCountry = this.locationLanguageService.doesCountryExists(this.selectedLocationLanguage.country, this.countries) ? this.selectedLocationLanguage.country : this.countries[0].value;
        this.selectedLanguage = this.locationLanguageService.doesLangaugeExists(this.selectedLocationLanguage.language, this.languages) ? this.selectedLocationLanguage.language : this.languages[0].value;
        this.locationLanguageSelectorForm.get('region').setValue(this.selectedRegion);
        this.locationLanguageSelectorForm.get('country').setValue(this.selectedCountry);
        this.locationLanguageSelectorForm.get('language').setValue(this.selectedLanguage);
    };
    SensitiveDataComponent.prototype.readLocationFromLocalStorage = function () {
        var parsedPreference = JSON.parse(localStorage.getItem("KCC.CP.selectedLocationLanguage"));
        this.selectedLocationLanguage = {
            region: parsedPreference.region,
            country: parsedPreference.country,
            language: parsedPreference.language
        };
    };
    SensitiveDataComponent.prototype.readQueryParams = function () {
        var languageFromParams = this.activatedRoute.snapshot.queryParamMap.get('language');
        var regionFromParams = this.activatedRoute.snapshot.queryParamMap.get('region');
        if (languageFromParams) {
            languageFromParams = languageFromParams.substring(0, 3).toLowerCase() + languageFromParams.substring(3).toUpperCase();
            this.selectedLocationLanguage =
                {
                    region: this.activatedRoute.snapshot.queryParamMap.get('region').toUpperCase(),
                    country: this.activatedRoute.snapshot.queryParamMap.get('country').toUpperCase(),
                    language: languageFromParams
                };
        }
        else if (regionFromParams) {
            this.onRegionChange({ value: regionFromParams });
        }
    };
    SensitiveDataComponent.prototype.onRegionChange = function (event) {
        var _this = this;
        var region = event.value;
        /** On region Change make the API call With Default en-US languagecode to get the Region country and location data */
        this.httpService.getLocationsWithDefaultLanguage("en-US").subscribe(function (locations) {
            if (locations && locations.response && locations.response.length) {
                _this.locationLanguageService.setLocationLanguageData(locations.response);
                _this.countries = _this.locationLanguageService.getCountriesForRegion(region);
                _this.languages = _this.locationLanguageService.getLanguagesForCountry(region, _this.countries[0].value);
                _this.selectedLocationLanguage = {
                    region: region,
                    country: (region == 'NA' ? _this.countries[1].value : _this.countries[0].value),
                    language: 'en-' + (region == 'NA' ? _this.countries[1].value : _this.countries[0].value)
                };
                _this._globalAppService.setDefaultRegion(_this.selectedLocationLanguage.region);
                _this.loadContactContent(_this.selectedLocationLanguage);
                _this.translateService.use(_this.selectedLocationLanguage.region + '/' + _this.languageService.getLanguageCode(_this.selectedLocationLanguage.region, _this.selectedLocationLanguage.language).toLowerCase());
                _this._globalAppService.setDefaultLanguage(_this.selectedLocationLanguage.language);
                _this.loadLocationLanguageData(true);
            }
        });
    };
    SensitiveDataComponent.prototype.onCountryChange = function (event) {
        var country = event.value;
        this.languages = this.locationLanguageService.getLanguagesForCountry(this.selectedLocationLanguage.region, country);
        this.selectedLocationLanguage = {
            region: this.selectedLocationLanguage.region,
            country: country,
            language: 'en-' + country //this.languages[0].value
        };
        this._globalAppService.setDefaultRegion(this.selectedLocationLanguage.region);
        this.loadContactContent(this.selectedLocationLanguage);
        this.translateService.use(this.selectedLocationLanguage.region + '/' + this.languageService.getLanguageCode(this.selectedLocationLanguage.region, this.selectedLocationLanguage.language).toLowerCase());
        this._globalAppService.setDefaultLanguage(this.selectedLocationLanguage.language);
        this.loadLocationLanguageData(true);
    };
    SensitiveDataComponent.prototype.onLanguageChange = function (event) {
        var _this = this;
        var language = event.value;
        this.selectedLocationLanguage = {
            region: this.selectedLocationLanguage.region,
            country: this.selectedLocationLanguage.country,
            language: language
        };
        this.translateService.get(['dataConfigData.waysToContactDropdown.select']).subscribe(function (translations) {
            _this.selectLabel = translations['dataConfigData.waysToContactDropdown.select'];
        });
        this.loadContactContent(this.selectedLocationLanguage);
        this.translateService.use(this.selectedLocationLanguage.region + '/' + this.languageService.getLanguageCode(this.selectedLocationLanguage.region, this.selectedLocationLanguage.language).toLowerCase());
        this._globalAppService.setDefaultRegion(this.selectedLocationLanguage.region);
        this._globalAppService.setDefaultLanguage(this.selectedLocationLanguage.language);
        this.loadLocationLanguageData(true);
    };
    SensitiveDataComponent.prototype.loadContactContent = function (selectedLocationLanguage) {
        var _this = this;
        this._appService.setLoadingStatus(true);
        if (this.countries && this.countries.length)
            this.selectedCountryLabel = this.countries.find(function (c) {
                return c.value === selectedLocationLanguage.country;
            }).label;
        this.selectedCountryValue = this.countries.find(function (c) {
            return c.value === selectedLocationLanguage.country;
        }).value;
        var request = {
            "regionId": selectedLocationLanguage.region,
            "countryId": selectedLocationLanguage.country,
            "languageCode": selectedLocationLanguage.language,
            "contentTypes": [
                {
                    "contentType": selectedLocationLanguage.region == 'EMEA' ? "Contacts" : 'RegisterContact'
                }
            ]
        };
        var footerRequest = {
            "regionId": selectedLocationLanguage.region,
            "countryId": selectedLocationLanguage.country,
            "languageCode": selectedLocationLanguage.language,
            "contentTypes": [
                {
                    "contentType": "GlobalFooter"
                }
            ]
        };
        this.httpService.getKCPContent(footerRequest).subscribe(function (data) {
            if (data && data.result && data.result.length > 0) {
                var dataResult = JSON.parse(data.result[0].data);
                _this.privacyPolicy = dataResult.privacypolicy;
                _this.legalStatement = dataResult.legalstatement;
            }
        });
    };
    /*
     #85393 Save the selection success message
     Changed by Laura Szmulewicz L55766
     Change date: 11/18/2022
   */
    SensitiveDataComponent.prototype.populateUserDetails = function () {
        var _this = this;
        this.httpService.getUserDetails().subscribe(function (userDetails) {
            _this._globalAppService.setUserDetails(userDetails.result);
            _this.userId = userDetails.result.userId;
            _this.CPRAdoNotSell = userDetails.result.cpraDonotSellPI || false;
            _this.CPRALimit = userDetails.result.cpraLimitUsePI || false;
            var CPRAFlag = _this.CPRAdoNotSell || _this.CPRALimit;
            localStorage.setItem('cpra-restriction-set', CPRAFlag ? 'true' : 'false');
        });
    };
    SensitiveDataComponent.prototype.saveUserDetails = function () {
        var _this = this;
        var doNotSellCheckbox = document.getElementById('do-not-sell');
        var limitCheckbox = document.getElementById('limit');
        this.CPRAdoNotSell = doNotSellCheckbox.checked;
        this.CPRALimit = limitCheckbox.checked;
        var objectToSend = {
            userId: this.userId,
            cpraDonotSellPI: this.CPRAdoNotSell,
            cpraLimitUsePI: this.CPRALimit
        };
        this.httpService.saveDetailsCPRA(objectToSend).subscribe(function (respone) {
            if (respone && respone.respone.isSaved) {
                //-- story #90174, to update the local storage after saving the details
                var CPRAFlag = _this.CPRAdoNotSell || _this.CPRALimit;
                localStorage.setItem('cpra-restriction-set', CPRAFlag ? 'true' : 'false');
                //--
                /*
                #87925 Save the selection success message
                Changed by Laura Szmulewicz L55766
                Change date: 11/18/2022
                */
                _this.messageService.clear();
                _this.messageService.add({ key: 'sensitiveDataSucess', severity: 'success', summary: 'sensitiveData.messageText.changesSaved.successHeader', detail: 'sensitiveData.messageText.changesSaved.sucessText', sticky: true });
            }
            else if (respone && respone.status != "OK") {
                _this.messageService.clear();
                _this.messageService.add({ key: 'sensitiveDataError', severity: 'error', summary: 'sensitiveData.messageText.error.errorHeader', detail: 'sensitiveData.messageText.error.errorText', sticky: true });
            }
            ;
        });
    };
    return SensitiveDataComponent;
}());
export { SensitiveDataComponent };
